import React, { useEffect } from "react";
import { LanguageUtils } from "../../language/LanguageUtils";
import Header from "../header";

interface ViewProps{
}

const View:React.FC<ViewProps> = (props: ViewProps) => {

    useEffect(() => {
        const scriptUrl = document.createElement('script');
        scriptUrl.type = 'text/javascript';
        scriptUrl.src = '../assets/js/common.min.js';
        document.body.appendChild(scriptUrl);

        const scriptUrl2 = document.createElement('script');
        scriptUrl2.type = 'text/javascript';
        scriptUrl2.src = '../assets/js/gsap.min.js';
        document.body.appendChild(scriptUrl2);
    },[]);

    return(
    <>
        <title>GAME | PROJECT ZIRCON（プロジェクト ジルコン） 公式サイト</title>
        <Header />
        <div className="wrapper">
            <div className="gem_wrap back">
                <div className="gem" id="gem_back"></div>
            </div>
            <div className="gem_wrap front">
                <div className="gem" id="gem_front"></div>
            </div>
            <header id="incHd"></header>
            <main>
                <div className="about">
                    <section className="subpage_header">
                        <div className="compass_wrap">
                            <p className="bg_compass"><img src="../assets/img/bg_compass_anime.svg" alt="" width="6058" height="6058"/></p>
                        </div>
                        <h2 className="ttl_deco_side">
                            <span className="en">GAME</span>
                            <span className="jp">{LanguageUtils.getLanguageData().about_about}</span>
                        </h2>
                    </section>
                    <section className="join_area bg_black">
                        <div className="inner">
                            <h3 className="elm_ttl fadeup">《 {LanguageUtils.getLanguageData().about_category_title_01} 》</h3>
                            {
                                LanguageUtils.getLanguage() == "ja" ? 
                                    <div className="img fadeup"><img src="../assets/img/about/prologue_japanese.jpg" alt="参加するには？" width="1200" height="675"/></div> :
                                    <div className="img fadeup"><img src="../assets/img/about/prologue_english.jpg" alt="参加するには？" width="1200" height="675"/></div>
                            }
                            <p className="txt fadeup" dangerouslySetInnerHTML={{__html: LanguageUtils.getLanguageData().about_category_text_01}}></p>
                        </div>
                    </section>

                    <section className="join_area bg_black">
                        <div className="inner">
                            <h3 className="elm_ttl fadeup">《 {LanguageUtils.getLanguageData().about_category_title_02} 》</h3>
                            {
                                LanguageUtils.getLanguage() == "ja" ? 
                                <div className="img fadeup"><img src="../assets/img/about/pack_japanese.jpg" alt="参加するには？" width="1200" height="675"/></div> :
                                <div className="img fadeup"><img src="../assets/img/about/pack_english.jpg" alt="参加するには？" width="1200" height="675"/></div>
                            }
                            <p className="txt fadeup" dangerouslySetInnerHTML={{__html: LanguageUtils.getLanguageData().about_category_text_02}}></p>
                        </div>
                    </section>

                    <section className="join_area bg_black">
                        <div className="inner">
                            <h3 className="elm_ttl fadeup">《 {LanguageUtils.getLanguageData().about_category_title_03} 》</h3>
                            {
                                LanguageUtils.getLanguage() == "ja" ? 
                                <div className="img fadeup"><img src="../assets/img/about/Straight_Flush_japanese.jpg" alt="参加するには？" width="1200" height="675"/></div> :
                                <div className="img fadeup"><img src="../assets/img/about/result_english.jpg" alt="参加するには？" width="1200" height="675"/></div>
                            }
                            <p className="txt fadeup" dangerouslySetInnerHTML={{__html: LanguageUtils.getLanguageData().about_category_text_03}}></p>
                        </div>
                    </section>

                    <section className="join_area bg_black">
                        <div className="inner">
                            <h3 className="elm_ttl fadeup">《 {LanguageUtils.getLanguageData().about_category_title_04} 》</h3>
                            {
                                LanguageUtils.getLanguage() == "ja" ? 
                                <div className="img fadeup"><img src="../assets/img/about/qween_japanese.jpg" alt="参加するには？" width="1200" height="675"/></div> :
                                <div className="img fadeup"><img src="../assets/img/about/qween_english.jpg" alt="参加するには？" width="1200" height="675"/></div>
                            }
                            <p className="txt fadeup" dangerouslySetInnerHTML={{__html: LanguageUtils.getLanguageData().about_category_text_04}}></p>
                        </div>
                    </section>

                    <section className="create_area bg_black">
                        <div className="inner">
                            <h3 className="elm_ttl fadeup">《 {LanguageUtils.getLanguageData().about_category_title_05} 》</h3>
                            <p className="txt fadeup" dangerouslySetInnerHTML={{__html: LanguageUtils.getLanguageData().about_category_text_05_1}}></p>
                            <div className="bnr fadeup"><a href={`${process.env.REACT_APP_STEAM_URL}`} target="_blank"><img src="../assets/img/about/SteamButton_White.png" alt="Project ZIRCON 公式Discord「ゲーム化検討委員会」" width="596" height="236"/></a></div>
                            <p className="steam-copyright-txt fadeup" dangerouslySetInnerHTML={{__html: LanguageUtils.getLanguageData().about_category_text_steam_copyright}}></p>
                            <br/>
                            

                            <p className="txt fadeup" dangerouslySetInnerHTML={{__html: LanguageUtils.getLanguageData().about_category_text_05_2}}></p>
                            <div className="bnr fadeup">
                                {
                                    LanguageUtils.getLanguage() == "ja" ? (
                                        // 日本語版のX
                                        <a href="https://x.com/project_zircon" target="_blank"><img src="../assets/img/about/plan_bnr_x.png" alt="PROJECT ZIRCON 公式X" width="596" height="160"/></a>
                                    ) : (
                                        // 英語版のX
                                        <a href="https://x.com/GAME_ZIRCON" target="_blank"><img src="../assets/img/about/about_x_en.png" alt="PROJECT ZIRCON 公式X" width="596" height="160"/></a>
                                    )
                                }
                            </div>
                        </div>
                    </section>
                </div>
            </main>
            <footer id="incFt"></footer>
        </div>
    </>
    );
};

export default View;